export const redirectToProductDetails = (productUrl) => {
  window.open(productUrl, '_blank');
};
